import * as React from 'react';

import Button from 'components/molecules/Button';
import i18n from 'helper/i18n';

const TutorialCardDetail = () => (
	<React.Fragment>
		<h2 className="m-tutorial__title">{i18n('react.impulsCoach.components.tutorialCardDetail.title')}</h2>
		<p className="m-tutorial__text">{i18n('react.impulsCoach.components.tutorialCardDetail.text')}</p>
		<ul className="m-tutorial-content">
			<li className="m-tutorial-content__item">
				<span className="m-tutorial-content__icon">
					<Button knob={{ modifier: 'dashed', size: 'l', icon: 'completed' }} />
				</span>
				<span className="m-tutorial-content__text">
					{i18n('react.impulsCoach.components.tutorialCardDetail.list.1')}
				</span>
			</li>
			<li className="m-tutorial-content__item">
				<span className="m-tutorial-content__icon">
					<Button knob={{ modifier: 'dashed', size: 'l', icon: 'heart' }} />
				</span>
				<span className="m-tutorial-content__text">
					{i18n('react.impulsCoach.components.tutorialCardDetail.list.2')}
				</span>
			</li>
		</ul>
	</React.Fragment>
);

export default TutorialCardDetail;
